import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';

export class UsersOfOrg extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.id;
    this.pageTitle = 'Clinic Admins'
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Orgs', to: '/admin/orgs/' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['users'], { orgId: this.orgId, pb: 'fieldDef' }) },
    ]
    this.tableHeaders = [
      'Phone',
      'First Name',
      'Last Name',
    ]
    this.emptyText = 'No users in this org yet!'
    this.apiData = {}
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef
    this.formDefinition.steps[0].fields =
      this.formDefinition.steps[0].fields.filter(i => Helper.inArray(['phone','givenname','familyname'], i.key))
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    switch (index) {
    case 0:
      return current.phone
    case 1:
      return current.givenname
    case 2:
      return current.familyname
    default:
      return ''
    }
  }

  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'addMembers',
        roles: ['SUPERUSER']
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.orgId]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'delMembers',
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.orgId]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'addMembers',
        roles: ['SUPERUSER']
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.orgId]),
    });
  }

  onActions(current) {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }

}


// WEBPACK FOOTER //
// ./src/screens/admin/UsersOfOrg.js